module.exports = __webpack_public_path__ + "c888326ff7e5fc4ca32a525e0820a845.ttf";